import EmojiConvertor from 'emoji-js'
import { DeltaOperation } from 'quill'

const emoji = new EmojiConvertor()
// eslint-disable-next-line @typescript-eslint/naming-convention
emoji.replace_mode = 'unified'
// eslint-disable-next-line @typescript-eslint/naming-convention
emoji.allow_native = true

const EXPANDABLE_ATTRIBUTE = 'expandable'

const TgHelper = {
  // eslint-disable-next-line complexity,max-statements,sonarjs/cognitive-complexity
  convertChild(quillItem: any, lastOps: any): void {
    if (quillItem.childNodes.length) {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < quillItem.childNodes.length; i++) {
        const itemChildNode = quillItem.childNodes[i]

        if (itemChildNode.nodeName === 'S') {
          if (lastOps.attributes) {
            lastOps.attributes.strike = true
          } else {
            lastOps.attributes = {
              strike: true,
            }
          }
        }
        if (itemChildNode.nodeName === 'U') {
          if (lastOps.attributes) {
            lastOps.attributes.underline = true
          } else {
            lastOps.attributes = {
              underline: true,
            }
          }
        }

        if (itemChildNode.nodeName === 'A') {
          if (lastOps.attributes) {
            lastOps.attributes.link = itemChildNode.getAttribute('href')
          } else {
            lastOps.attributes = {
              link: itemChildNode.getAttribute('href'),
            }
          }
        }

        if (itemChildNode.nodeName === 'B') {
          if (lastOps.attributes) {
            lastOps.attributes.bold = true
          } else {
            lastOps.attributes = {
              bold: true,
            }
          }
        }
        if (itemChildNode.nodeName === 'I') {
          if (lastOps.attributes) {
            lastOps.attributes.italic = true
          } else {
            lastOps.attributes = {
              italic: true,
            }
          }
        }

        if (itemChildNode.nodeName === 'CODE') {
          if (lastOps.attributes) {
            lastOps.attributes.code = true
          } else {
            lastOps.attributes = {
              code: true,
            }
          }
        }
        if (itemChildNode.nodeName === 'PRE') {
          if (lastOps.attributes) {
            lastOps.attributes.tgpre = true
          } else {
            lastOps.attributes = {
              tgpre: true,
            }
          }
        }
        if (itemChildNode.nodeName === 'TG-SPOILER') {
          if (lastOps.attributes) {
            lastOps.attributes.tgspoiler = true
          } else {
            lastOps.attributes = {
              tgspoiler: true,
            }
          }
        }

        if (itemChildNode.nodeName === 'BLOCKQUOTE' && !itemChildNode.parentNode.attributes.getNamedItem(EXPANDABLE_ATTRIBUTE)) {
          if (lastOps.attributes) {
            lastOps.attributes.blockquote = true
          } else {
            lastOps.attributes = {
              blockquote: true,
            }
          }
        }

        if (itemChildNode.nodeName === 'BLOCKQUOTE' && !!itemChildNode.parentNode.attributes.getNamedItem(EXPANDABLE_ATTRIBUTE)) {
          if (lastOps.attributes) {
            lastOps.attributes.blockquoteExpandable = true
          } else {
            lastOps.attributes = {
              blockquoteExpandable: true,
            }
          }
        }

        TgHelper.convertChild(itemChildNode, lastOps)
      }
    }
  },

  // eslint-disable-next-line complexity,max-statements,sonarjs/cognitive-complexity
  convert(text: string): any {
    const parsedHtml = new DOMParser().parseFromString(text, 'text/html')
    const { childNodes } = parsedHtml.querySelectorAll('body')[0]
    const ops: Array<DeltaOperation> = []

    for (const childNode of childNodes) {
      if (childNode.nodeName === 'BR') {
        ops.push({
          insert: '\n',
        })
      }
      if (childNode.nodeName === '#text') {
        ops.push({
          insert: childNode.textContent,
        })
      }
      if (childNode.nodeName === 'B') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            bold: true,
          },
        })
      }
      if (childNode.nodeName === 'I') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            italic: true,
          },
        })
      }

      if (childNode.nodeName === 'S') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            strike: true,
          },
        })
      }
      if (childNode.nodeName === 'U') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            underline: true,
          },
        })
      }

      if (childNode.nodeName === 'A') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            link: (childNode as HTMLLinkElement).getAttribute('href'),
          },
        })
      }
      if (childNode.nodeName === 'CODE') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            code: true,
          },
        })
      }
      if (childNode.nodeName === 'PRE') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            tgpre: true,
          },
        })
      }
      if (childNode.nodeName === 'TG-SPOILER') {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            tgspoiler: true,
          },
        })
      }

      if (childNode.nodeName === 'BLOCKQUOTE' && !(childNode as Element).attributes.getNamedItem(EXPANDABLE_ATTRIBUTE)) {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            blockquote: true,
          },
        })
      }

      if (childNode.nodeName === 'BLOCKQUOTE' && !!(childNode as Element).attributes.getNamedItem(EXPANDABLE_ATTRIBUTE)) {
        ops.push({
          insert: childNode.textContent,
          attributes: {
            blockquoteExpandable: true,
          },
        })
      }

      TgHelper.convertChild(childNode, [ ...ops ].pop())
    }

    return ops
  },

  convertTelegramHtmlToQuillContents(str: string): any {
    if (typeof str === 'undefined' || str === null) {
      return ''
    }

    let strNl2Br = str

    // strNl2Br = strNl2Br.replace(/<\/pre>[ ]*<pre>/g, '</pre>\n<pre>');
    strNl2Br = strNl2Br.replace(/<\/pre><pre>/gu, '</pre>\n<pre>')
    strNl2Br = strNl2Br.replace(/\n/gu, '<br/>')

    return { ops: TgHelper.convert(strNl2Br) }
  },

  // eslint-disable-next-line complexity,max-statements,sonarjs/cognitive-complexity
  convertQuillContentsToTelegramHtml(quillContents: any): any {
    let ret = ''

    if (quillContents.ops) {
      for (const element of quillContents.ops) {
        if (element.insert) {
          let before = ''
          let after = ''

          if (element.attributes) {
            // eslint-disable-next-line max-depth
            if (element.attributes.bold === true) {
              before = `${ before }<b>`
              after = `</b>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.italic === true) {
              before = `${ before }<i>`
              after = `</i>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.strike === true) {
              before = `${ before }<s>`
              after = `</s>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.underline === true) {
              before = `${ before }<u>`
              after = `</u>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.tgpre === true) {
              before = `${ before }<pre>`
              after = `</pre>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.tgspoiler === true) {
              before = `${ before }<tg-spoiler>`
              after = `</tg-spoiler>${ after }`
            }

            if (element.attributes.blockquoteExpandable === true) {
              before = `${ before }<blockquote expandable>`
              after = `</blockquote>${ after }`
            }

            if (element.attributes.blockquote === true) {
              before = `${ before }<blockquote>`
              after = `</blockquote>${ after }`
            }

            // eslint-disable-next-line max-depth
            if (element.attributes.code === true) {
              before = `${ before }<code>`
              after = `</code>${ after }`
            }
            // eslint-disable-next-line max-depth
            if (element.attributes.link) {
              before = `${ before }<a href="${ element.attributes.link }">`
              after = `</a>${ after }`
            }

            if (element.insert.emoji) {
              ret += before + emoji.replace_colons(`:${ element.insert.emoji }:`) + after
            }

            if (element.insert.placeholders) {
              ret += before + element.insert.placeholder.id + after
            }

            if (!element.insert.emoji) {
              ret += before + element.insert + after
            }

          } else if (element.insert.placeholder) {
            ret += before + element.insert.placeholder.id + after
          } else if (element.insert.emoji) {
            ret += before + emoji.replace_colons(`:${ element.insert.emoji }:`) + after
          } else {
            ret += before + element.insert + after
          }
        }
      }
    }

    return ret
  },
}

export default TgHelper
